/**
 * @packageDocumentation
 * Wraps Howler-based audio management for background music, win stingers, and UI cues.
 */
import {Howl, Howler} from 'howler';
import { gsap } from 'gsap/gsap-core'; 

/**
 * Handles muting sounds when switching browser tabs
 */
const isIphone: boolean = /iPhone/i.test(navigator.userAgent); 
(window as any).isActive = true;

/**
 * Toggles Howler audio muting based on window/tab active state
 * @param isActive - Whether the window/tab is currently active
 */
function toggleHowlerMute(isActive: boolean): void {
    console.log(!isActive)
    if (!isIphone) {
    Howler.mute(!isActive);
    }
} 

window.addEventListener('focus', () => {
    console.log("window focused");
    const s = SoundManager.getGameSound();
    if(s == "true") {
        (window as any).isActive = true;
        toggleHowlerMute((window as any).isActive);
    }
});

document.addEventListener('visibilitychange', () => {
    console.log("window focus changed"); 
    const s = SoundManager.getGameSound();
    if(s == "true") {
        const isVisible = document.visibilityState !== 'hidden';
        (window as any).isActive = isVisible;
        toggleHowlerMute((window as any).isActive);
    }
});





 







/**
 * Manages all game sound effects and music
 */
export class SoundManager{
    static getBgSound = () => sessionStorage.getItem("Bg_Sound");
    static setBgSound = (s: boolean) => sessionStorage.setItem("Bg_Sound", `${s}`);
    static getGameSound = () => sessionStorage.getItem("Game_Sound");
    static setGameSound = (s: boolean) => sessionStorage.setItem("Game_Sound", `${s}`);
    /** Background music instance */
    static Bgmusic_Bonus = new Howl({
        src: [ 'assets/Sounds/new/Bgmusic_Bonus.webm','assets/Sounds/new/Bgmusic_Bonus.mp3'],loop:true,volume: 0.3
      });
    static Bgmusic_Main = new Howl({
        src: [ 'assets/Sounds/new/Bgmusic_Main.webm','assets/Sounds/new/Bgmusic_Main.mp3'],loop:true,volume: 0.3
      });
    static Bonus_Celebration = new Howl({
        src: [ 'assets/Sounds/new/Bonus_Celebration.webm','assets/Sounds/new/Bonus_Celebration.mp3'],loop:false,volume: 1
      });
    static Bonus_Enter_Transition = new Howl({
        src: [ 'assets/Sounds/new/Bonus_Enter_Transition.webm','assets/Sounds/new/Bonus_Enter_Transition.mp3'],loop:false,volume: 1
      });
    static Bonus_Exit_Transition = new Howl({
        src: [ 'assets/Sounds/new/Bonus_Exit_Transition.webm','assets/Sounds/new/Bonus_Exit_Transition.mp3'],loop:false,volume: 0.25
      });
    static Bonus_Win_Robot_reveals_win = new Howl({
        src: [ 'assets/Sounds/new/Bonus_Win_Robot_reveals_win.webm','assets/Sounds/new/Bonus_Win_Robot_reveals_win.mp3'],loop:false,volume: 1
      });
    static Border_win = new Howl({
        src: [ 'assets/Sounds/new/Border_win.webm','assets/Sounds/new/Border_win.mp3'],loop:false,volume: 1
      });
    static Box_Shatter = new Howl({
        src: [ 'assets/Sounds/new/Box_Shatter.webm','assets/Sounds/new/Box_Shatter.mp3'],loop:false,volume: 1
      });
    static Card_Normal_Flip = new Howl({
        src: [ 'assets/Sounds/new/Card_Normal_Flip.webm','assets/Sounds/new/Card_Normal_Flip.mp3'],loop:false,volume: 1
      });
    static Card_Slow_Flip = new Howl({
        src: [ 'assets/Sounds/new/Card_Slow_Flip.webm','assets/Sounds/new/Card_Slow_Flip.mp3'],loop:false,volume: 1
      });
    static Civilian_Character_Win = new Howl({
        src: [ 'assets/Sounds/new/Civilian_Character_Win.webm','assets/Sounds/new/Civilian_Character_Win.mp3'],loop:false,volume: 1
      });
    static Heroes_Character_Win = new Howl({
        src: [ 'assets/Sounds/new/Heroes_Character_Win.webm','assets/Sounds/new/Heroes_Character_Win.mp3'],loop:false,volume: 1
      });
    static Lose_Sound = new Howl({
        src: [ 'assets/Sounds/new/Lose_Sound.webm','assets/Sounds/new/Lose_Sound.mp3'],loop:false,volume: 1
      });
    static Robot_Powerup = new Howl({
        src: [ 'assets/Sounds/new/Robot_Powerup.webm','assets/Sounds/new/Robot_Powerup.mp3'],loop:false,volume: 1
      });
    static Robot_Shoot_sound1 = new Howl({
        src: [ 'assets/Sounds/new/Robot_Shoot_sound1.webm','assets/Sounds/new/Robot_Shoot_sound1.mp3'],loop:false,volume: 1
      });
    static Wild_Card_Flip = new Howl({
        src: [ 'assets/Sounds/new/Wild_Card_Flip.webm','assets/Sounds/new/Wild_Card_Flip.mp3'],loop:false,volume: 1
      });
    static Win_Popup = new Howl({
        src: [ 'assets/Sounds/new/Win_Popup.webm','assets/Sounds/new/Win_Popup.mp3'],loop:false,volume: 0.25
      });

    /** Particle movement sound effect */
    static particle_move = new Howl({
        src: [ './assets/Sounds/particle_move.webm','./assets/Sounds/particle_move.mp3'],loop:false,volume:0.5
      });

    /** Button click sound effect */
    static Btnclick_1 = new Howl({
        src: [ './assets/Sounds/Button_click.webm','./assets/Sounds/Button_click.mp3'],loop:false
      });

    /** Spin button click sound */
    static SpinClick = new Howl({
        src: [ './assets/Sounds/Spin_click.webm','./assets/Sounds/Spin_click.mp3'],loop:false
      });

    /** First spin sound effect */
    static SpinSound_1 = new Howl({
        src: [ './assets/Sounds/SpinSound_1.webm','./assets/Sounds/SpinSound_1.mp3'],loop:true
      });

    /** Second spin sound effect */
    static SpinSound_2 = new Howl({
        src: [ './assets/Sounds/SpinSound_2.webm','./assets/Sounds/SpinSound_2.mp3'],loop:false
      });

    /** Explosion sound effect */
    static blast = new Howl({
        src: [ './assets/Sounds/blast.webm','./assets/Sounds/blast.mp3'],loop:false
      });

    /** Coin down movement sound */
    static coinDown = new Howl({
        src: [ './assets/Sounds/coinDown.webm','./assets/Sounds/coinDown.mp3'],loop:false
      });

    /** Coin up movement sound */
    static coinUp = new Howl({
        src: [ './assets/Sounds/coinUp.webm','./assets/Sounds/coinUp.mp3'],loop:false
      });

    /** Coin collection sound */
    static coinCollect = new Howl({
        src: [ './assets/Sounds/coinCollect.webm','./assets/Sounds/coinCollect.mp3'],loop:false
      });

    /** Box falling sound effect */
    static box_falling = new Howl({
        src: [ './assets/Sounds/box_falling.webm','./assets/Sounds/box_falling.mp3'],loop:false,volume:0.25
      });

    /** Whoosh sound effect */
    static Whoosh = new Howl({
        src: [ './assets/Sounds/Whoosh.webm','./assets/Sounds/Whoosh.mp3'],loop:false
      });

    /** Coin flip lose sound */
    static Coinflip_lose = new Howl({
        src: [ './assets/Sounds/Coinflip_lose.webm','./assets/Sounds/Coinflip_lose.mp3'],loop:false
      });

    /** Coin flip win sound */
    static Coinflip_win = new Howl({
        src: [ './assets/Sounds/Coinflip_win.webm','./assets/Sounds/Coinflip_win.mp3'],loop:false
      });

    /** Coin flip transition sound */
    static Coinflip_transition = new Howl({
        src: [ './assets/Sounds/Coinflip_transition.webm','./assets/Sounds/Coinflip_transition.mp3'],loop:false
      });

    /** Coin flip toss sound */
    static Coinflip_toss = new Howl({
        src: [ './assets/Sounds/Coinflip_toss.webm','./assets/Sounds/Coinflip_toss.mp3'],loop:false
      });

    /** Final transition sound */
    static Final_transition = new Howl({
        src: [ './assets/Sounds/Final_transition.webm','./assets/Sounds/Final_transition.mp3'],loop:false
      });

    /** End popup ambient sound */
    static end_popup_ambience = new Howl({
        src: [ './assets/Sounds/end_popup_ambience.webm','./assets/Sounds/end_popup_ambience.mp3'],loop:true
      });

    /** Win increment sound */
    static win_increment = new Howl({
        src: [ './assets/Sounds/win_increment.webm','./assets/Sounds/win_increment.mp3'],loop:false
      });

    /** End popup lose sound */
    static end_popup_lose = new Howl({
        src: [ './assets/Sounds/end_popup_lose.webm','./assets/Sounds/end_popup_lose.mp3'],loop:false
      });

    /** End popup win sound */
    static end_popup_win = new Howl({
        src: [ './assets/Sounds/end_popup_win.webm','./assets/Sounds/end_popup_win.mp3'],loop:true
      });

    /** Gauge complete sound */
    static gauge_complete = new Howl({
        src: [ './assets/Sounds/gauge_complete.webm','./assets/Sounds/gauge_complete.mp3'],loop:false
      });

    /** Gauge filling sound */
    static gauge_filling = new Howl({
        src: [ './assets/Sounds/gauge_filling.webm','./assets/Sounds/gauge_filling.mp3'],loop:false
      });

    /** Minigame background music */
    static bgmusic_minigame = new Howl({
        src: [ './assets/Sounds/bgmusic_minigame.webm','./assets/Sounds/bgmusic_minigame.mp3'],loop:true,volume:0.5
      });

    /** Big win sound effect */
    static big_win_snd = new Howl({
        src: [ './assets/Sounds/big_win_snd.webm','./assets/Sounds/big_win_snd.mp3'],loop:false
      });

    /** Mega win sound effect */
    static mega_win_snd = new Howl({
        src: [ './assets/Sounds/mega_win_snd.webm','./assets/Sounds/mega_win_snd.mp3'],loop:false
      });

    /** Super win sound effect */
    static super_win_snd = new Howl({
        src: [ './assets/Sounds/super_win_snd.webm','./assets/Sounds/super_win_snd.mp3'],loop:false
      });

    /** History sound effect */
    static history_snd = new Howl({
        src: [ './assets/Sounds/history_snd.webm','./assets/Sounds/history_snd.mp3'],loop:false
      });

    /** Plays background music */
    static bgMusicSndPlay(){
        SoundManager.Bgmusic_Main.play()
    }

    /** Stops background music */
    static bgMusicSndStop(){
        SoundManager.Bgmusic_Main.stop()
    }

    /** Plays button click sound */
    static Btnclick_1SndPlay(){
        SoundManager.Btnclick_1.play()
    }

    /** Stops button click sound */
    static Btnclick_1SndStop(){
        SoundManager.Btnclick_1.stop()
    }

    /** Plays spin click sound */
    static spinClickSndPlay(){
        SoundManager.SpinClick.play()
    }

    /** Stops spin click sound */
    static spinClickSndStop(){
        SoundManager.SpinClick.stop()
    }
   
    /** Plays second spin sound */
    static SpinSound_2SndPlay(){
        SoundManager.SpinSound_2.play()
    }

    /** Stops second spin sound */
    static SpinSound_2SndStop(){
        SoundManager.SpinSound_2.stop()
    }

    /** Plays blast sound effect twice */
    static blastSndPlay(){
        SoundManager.blast.play()
        SoundManager.blast.play()
    }

    /** Stops blast sound */
    static blastSndStop(){
        SoundManager.blast.stop()
    }

    /** Plays coin down sound */
    static coinDownSndPlay(){
        SoundManager.coinDown.play()
    }

    /** Stops coin down sound */
    static coinDownSndStop(){
        SoundManager.coinDown.stop()
    }

    /** Plays coin up sound */
    static coinUpSndPlay(){
        SoundManager.coinUp.play()
    }

    /** Stops coin up sound */
    static coinUpSndStop(){
        SoundManager.coinUp.stop()
    }

    /** Plays coin collect sound */
    static coinCollectSndPlay(){
        SoundManager.coinCollect.play()
    }

    /** Stops coin collect sound */
    static coinCollectSndStop(){
        SoundManager.coinCollect.stop()
    }

    /** Plays box falling sound */
    static box_fallingSndPlay(){
        SoundManager.box_falling.play()
    }

    /** Stops box falling sound */
    static box_fallingSndStop(){
        SoundManager.box_falling.stop()
    }

    /** Plays whoosh sound */
    static WhooshSndPlay(){
        SoundManager.Whoosh.play()
    }

    /** Stops whoosh sound */
    static WhooshSndStop(){
        SoundManager.Whoosh.stop()
    }

    /** Plays coin flip transition sound */
    static Coinflip_transitionSndPlay(){
        SoundManager.Coinflip_transition.play()
    }

    /** Stops coin flip transition sound */
    static Coinflip_transitionSndStop(){
        SoundManager.Coinflip_transition.stop()
    }

    /** Plays coin flip toss sound */
    static Coinflip_tossSndPlay(){
        SoundManager.Coinflip_toss.play()
    }

    /** Stops coin flip toss sound */
    static Coinflip_tossSndStop(){
        SoundManager.Coinflip_toss.stop()
    }

    /** Plays coin flip win sound */
    static Coinflip_winSndPlay(){
        SoundManager.Coinflip_win.play()
    }

    /** Stops coin flip win sound */
    static Coinflip_winSndStop(){
        SoundManager.Coinflip_win.stop()
    }

    /** Plays coin flip lose sound */
    static Coinflip_loseSndPlay(){
        SoundManager.Coinflip_lose.play()
    }

    /** Stops coin flip lose sound */
    static Coinflip_loseSndStop(){
        SoundManager.Coinflip_lose.stop()
    }

    /** Plays final transition sound */
    static Final_transitionSndPlay(){
        SoundManager.Final_transition.play()
    }

    /** Stops final transition sound */
    static Final_transitionSndStop(){
        SoundManager.Final_transition.stop()
    }

    /** Unmutes all game sounds */
    static PlayGameSoundFun(){
        Howler.mute(false)
    }

    /** Mutes all game sounds */
    static MuteGameSoundFun(){
        Howler.mute(true)
    }

    /** Unmutes background music */
    static PlayBgMusicFun(){
        if(!SoundManager.Bgmusic_Main.playing()){
            SoundManager.Bgmusic_Main.play()
        }
        SoundManager.Bgmusic_Main.mute(false)
        SoundManager.Bgmusic_Bonus.mute(false)
    }

    /** Mutes background music */
    static MuteBgMusicFun(){
        SoundManager.Bgmusic_Main.mute(true);
        SoundManager.Bgmusic_Bonus.mute(true);
    }
 
    /** Plays end popup ambient sound */
    static end_popup_ambiencePlay(){
        SoundManager.end_popup_ambience.play()
    }

    /** Stops end popup ambient sound */
    static end_popup_ambienceStop(){
        SoundManager.end_popup_ambience.stop()
    }

    /** Plays win increment sound */
    static win_incrementPlay(){
        SoundManager.win_increment.play()
    }

    /** Stops win increment sound */
    static win_incrementStop(){
        SoundManager.win_increment.stop()
    }

    /** Plays end popup lose sound */
    static end_popup_losePlay(){
        SoundManager.end_popup_lose.play()
    }

    /** Stops end popup lose sound */
    static end_popup_loseStop(){
        SoundManager.end_popup_lose.stop()
    }

    /** Plays end popup win sound */
    static end_popup_winPlay(){
        SoundManager.end_popup_win.play()
    }

    /** Stops end popup win sound */
    static end_popup_winStop(){
        SoundManager.end_popup_win.stop()
    }

    /** Plays gauge complete sound */
    static gauge_completePlay(){
        SoundManager.gauge_complete.play()
    }

    /** Stops gauge complete sound */
    static gauge_completeStop(){
        SoundManager.gauge_complete.stop()
    }

    /** Plays gauge filling sound */
    static gauge_fillingPlay(){
        SoundManager.gauge_filling.play()
    }

    /** Stops gauge filling sound */
    static gauge_fillingStop(){
        SoundManager.gauge_filling.stop()
    }

    /** Plays minigame background music */
    static bgmusic_minigamePlay(){
        SoundManager.Bgmusic_Bonus.play()
    }

    /** Stops minigame background music */
    static bgmusic_minigameStop(){
        SoundManager.Bgmusic_Bonus.stop()
    }

    /** Fades out minigame music */
    static fadedown_minigame(){
        gsap.to(SoundManager.Bgmusic_Bonus,{duration:1,volume:0,onComplete:()=>{
            SoundManager.Bgmusic_Bonus.volume(0.5);
            SoundManager.Bgmusic_Bonus.stop() 
        }})
    }

    /** Fades in minigame music */
    static fadeup_minigame(){
        gsap.to(SoundManager.Bgmusic_Bonus,{duration:1,volume:1})
    }
    
}
